export default __webpack_public_path__ + "static/martina-plantijn-web-regular-14da753a421f545364d74c4aee429779.woff2";